import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles((theme) => {
    const { primary3Color } = theme.palette;
    const { textFontSize, textColor } = theme.textField;

    return {
        actions: {
            padding: theme.spacing(1, 2),

            [theme.breakpoints.down('xs')]: {
                padding: theme.spacing(1, 0.5),
            },
        },
        content: {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            minWidth: 300,
        },
        formControl: {
            margin: theme.spacing(0.5, 0),
            flexBasis: '100%',
        },
        input: {
            height: '1.4em',
        },
        label: {
            fontSize: '18px',
            color: primary3Color,
        },
        picker: {
            margin: theme.spacing(0.5, 0),
            flexBasis: '49%',

            [theme.breakpoints.down('xs')]: {
                flexBasis: '100%',
            },
        },
        priority: {
            margin: theme.spacing(0.5, 0),
            flexBasis: '49%',

            [theme.breakpoints.down('xs')]: {
                flexBasis: '100%',
            },
        },
        quantity: {
            margin: theme.spacing(0.5, 0),
            flexBasis: '49%',

            [theme.breakpoints.down('xs')]: {
                flexBasis: '100%',
            },
        },
        text: {
            marginTop: '4px',
            padding: theme.spacing(0, 0, 0.5),

            fontSize: textFontSize,
            borderBottom: '1px solid rgba(0, 0, 0, 0.298039)',
            color: textColor,
        },
        textarea: {
            '& .MuiInput-root': {
                height: 'auto',
            },
        },
        title: {
            padding: theme.spacing(2, 2, 0),

            [theme.breakpoints.down('xs')]: {
                padding: theme.spacing(2, 1, 0),
            },
        },
        valueInput: {
            [theme.breakpoints.up('sm')]: {
                width: 150,
            },
        },
    };
});
